// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

interface ImageData {
  src: string;
  duration: number;
}

@Component({
  mixins: [template],
})
export class ImageFader extends Vue {
  @Prop({ default: () => [] })
  public imageData!: ImageData[];

  @Prop({ default: false })
  public active!: boolean;

  @Prop({ default: true })
  public loop!: boolean;

  private currentIndex = 0;

  private currentImage: string = "";

  private timer: number | null = null;

  mounted() {
    this.fadeLoop();
  }

  @Watch("active")
  public onActiveChange(value) {
    if (value) {
      this.restart();
    }
  }

  private restart() {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.currentIndex = 0;
    this.fadeLoop();
  }

  private fadeLoop() {
    if (this.currentIndex >= this.imageData.length) {
      this.currentIndex = 0;
    }
    this.currentImage = this.imageData[this.currentIndex].src;
    let duration = this.imageData[this.currentIndex].duration;

    this.timer = <any>setTimeout(() => {
      this.currentIndex = this.getNextIndex();
      if ((this.currentIndex == 0 && this.loop) || this.currentIndex > 0) {
        this.fadeLoop();
      }
    }, duration * 1000);
  }

  private getNextIndex() {
    let next = this.currentIndex + 1;
    if (next > this.imageData.length - 1) {
      next = 0;
    }

    return next;
  }
}
